<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>
        <div class="container-fluid mt-5">
          <!-- breadcrumb and title row starts -->
          <div class="row">
            <div class="col-sm-12 print-scr">
              <vs-breadcrumb
                align="left"
                :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/program-officer/todoList'
                    },
                   
                    {
                      title: 'Registration Report',
                      active: true
                    }
                  ]"
              ></vs-breadcrumb>
              
            </div>
            <div class="col-sm-12">
 <div class="heading mt-3">
                <h3 class="text-secondary">Registration Report</h3>
              </div>
            </div>
           
          </div>
          <!-- breadcrumb and title row Ends -->
          <!-- report row starts  -->
          <div class="row">
            <div class="col-sm-12">
              <span class="btn btn-primary float-right btn-sm print-btn" @click="printReport">
                <i class="material-icons">print</i> Print
              </span>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <!-- form starts  -->
              <form style="border: 1px solid #06a6e0;padding: 20px 10px;">
                <!-- form row 1 starts -->
                <div class="form-group row">
                  <!-- col First Name starts -->
                  <div class="col-sm-4 mrgn-bot">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>First Name</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="Muhammad"
                    />
                  </div>
                  <!-- col First Name Ends -->
                  <!-- --------------------------- -->
                  <!-- col Family Name starts -->
                  <div class="col-sm-4 mrgn-bot">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Family Name</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="Ammad"
                    />
                  </div>
                  <!-- col Family Name Ends -->
                  <!-- --------------------------- -->
                  <!-- col Gender starts -->
                  <div class="col-sm-4">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Gender</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="Male"
                    />
                  </div>
                  <!-- col Gender Ends -->
                </div>
                <!-- form row 1 Ends -->
                <!-- ---------------------------- -->
                <!-- form row 2 starts -->
                <div class="form-group row">
                  <!-- col Designation starts -->
                  <div class="col-sm-4 mrgn-bot">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Designation</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="Web Cum Graphics Designer"
                    />
                  </div>
                  <!-- col Designation Ends -->
                  <!-- --------------------------- -->
                  <!-- col Education starts -->
                  <div class="col-sm-4 mrgn-bot">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Education</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="Bachelor of Computer Science"
                    />
                  </div>
                  <!-- col Education Ends -->
                  <!-- --------------------------- -->
                  <!-- col Employer starts -->
                  <div class="col-sm-4">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Employer</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="Next Generation Circle"
                    />
                  </div>
                  <!-- col Employer Ends -->
                  <!-- --------------------------- -->
                </div>
                <!-- form row 2 Ends -->
                <!-- ---------------------------- -->
                <!-- form row 3 starts -->
                <div class="form-group row">
                  <!-- col Address starts -->
                  <div class="col-sm-8 mrgn-bot">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Office Address</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="Hussain Abad Road, Near Bunyadi Dispensary, and Opposite of ST-Thomas School, Peshawar  "
                    />
                  </div>
                  <!-- col Address Ends -->
                  <!-- --------------------------- -->
                  <!-- col Office Phone No starts -->
                  <div class="col-sm-4 ">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Office Phone No</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="0321-9943774"
                    />
                  </div>
                  <!-- col Office Phone No -->
                  <!-- --------------------------- -->
                </div>
                <!-- form row 3 Ends -->
                <!-- ---------------------------- -->
                <!-- form row 4 starts -->
                <div class="form-group row">
                  <!-- col Fax No starts -->
                  <div class="col-sm-3 mrgn-bot">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Fax No</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="(+92-91) 9216663"
                    />
                  </div>
                  <!-- col Fax No Ends -->
                  <!-- --------------------------- -->
                  <!-- col Cell Phone No starts -->
                  <div class="col-sm-3 mrgn-bot">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Cell Phone No</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="0321-9943774"
                    />
                  </div>
                  <!-- col Cell Phone No Ends -->
                  <!-- --------------------------- -->
                  <!-- col Email starts -->
                  <div class="col-sm-6">
                    <label style="color:#6c757d;" for="formGroupExampleInput">
                      <b>Email</b>
                    </label>
                    <input
                      style="border-bottom:2px solid #eaeaea;border-left: none;border-top: none;border-right: none;box-shadow: none !important;background-color:transparent;"
                      type="text"
                      readonly
                      class="form-control"
                      id="disabledTextInput"
                      value="ammad2090@gmail.com"
                    />
                  </div>
                  <!-- col Email Ends -->
                  <!-- --------------------------- -->
                </div>
                <!-- form row 4 Ends -->
                <!-- ---------------------------- -->
              </form>
              <!-- form ends  -->
            </div>
          </div>
          <!-- report row ends  -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
// import axios from "axios";
export default {
  data: () => ({
    isSidebar: false
  }),
  mounted() {},
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    printReport: function() {
      window.print();
    }
  },
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar
  }
};
</script>

<style scoped>
@media print {
  .print-scr {
    display: none;
  }
  .print-btn {
    display: none;
  }
  .cont-bdr {
    display: block;
  }
  .heading {
    display: block;
  }
}
@media screen and (max-width: 600px) {
  .mrgn-bot{
    margin-bottom: 1rem !important;
  }
}
</style>